var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandsClapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 286.101,
    height: 199.001,
    viewBox: "0 0 286.101 199.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M582.873,354.308a57.469,57.469,0,0,1-5.95,6.237c-4.45,4.018-12.439,6.765-24.11,8.049-16.661,1.835-40.819.7-72.906-3.994-46.1-6.741-111.206,11.551-143.869,2.063a32.358,32.358,0,0,1-12.1-6.129c-8.744-7.437-13.291-15.666-15.27-24.566-3.9-17.525,2.171-37.665,5.842-59.531a169.372,169.372,0,0,0,2.375-21.315,102.675,102.675,0,0,0-.8-18.125c-6.729-49.156,23.882-74.453,62.59-64.342,34.282,8.948,94.893,9.2,148.907,1.068,43.074-6.477,74.681,17.057,58.32,57.576-4.714,11.683-4.318,24.11-2.2,36.753.132.8.276,1.607.432,2.423,1.775,9.656,4.438,19.42,6.465,29.04q.792,3.742,1.427,7.449C594.856,323.78,594.544,339.986,582.873,354.308Z",
    transform: "translate(-307.407 -170.454)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_26921951_Hands_clapping_and_giving_thumbs_up_Converted_",
    "data-name": "26921951_Hands clapping and giving thumbs up [Converted]",
    transform: "translate(-307.407 -170.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M582.873,354.308a57.469,57.469,0,0,1-5.95,6.237c-4.45,4.018-12.439,6.765-24.11,8.049-16.661,1.835-40.819.7-72.906-3.994-46.1-6.741-111.206,11.551-143.869,2.063a32.358,32.358,0,0,1-12.1-6.129c-8.744-7.437-13.291-15.666-15.27-24.566-3.9-17.525,2.171-37.665,5.842-59.531a169.372,169.372,0,0,0,2.375-21.315,102.675,102.675,0,0,0-.8-18.125c-6.729-49.156,23.882-74.453,62.59-64.342,34.282,8.948,94.893,9.2,148.907,1.068,43.074-6.477,74.681,17.057,58.32,57.576-4.714,11.683-4.318,24.11-2.2,36.753.132.8.276,1.607.432,2.423,1.775,9.656,4.438,19.42,6.465,29.04q.792,3.742,1.427,7.449C594.856,323.78,594.544,339.986,582.873,354.308Z",
    transform: "translate(-307.407 -170.454)",
    fill: "#dae6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(138.045 99.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(2.999 19.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1541.793,1253.4a56.5,56.5,0,0,1-7.857,3.551c-5.626,2.063-14.058,1.631-25.37-1.547-1.283-7.293-6.693-38.864-7.293-42.091-.684-3.671-1.163-6.453-1.439-7.7a3.787,3.787,0,0,0-.192-.7c-2.447-4.078-1.571-4.378-6.141-7.7-.576-.42-1.128-.936-1.763-1.355-5.7-3.791-7.389-6.969-7.917-7.9-.168-.3-.48-1.3-.492-1.3a.317.317,0,0,1-.06-.2,11.533,11.533,0,0,1,1.847-4.774,1.753,1.753,0,0,1,.108-.156c.084-.12.156-.24.24-.348.06-.084.12-.168.192-.252.012-.012.024-.024.024-.036.492-.612.852-1.044.948-1.14s.2-.18.312-.264a2.838,2.838,0,0,1,1.271-.492,4.856,4.856,0,0,1,2.675.564s.048-.132.156-.384l.048-.108c.192-.48.516-1.3.924-2.315.012-.048.036-.084.048-.132q.108-.252.216-.54l.1-.228c.012-.012.012-.036.024-.06l.012-.036c.216-.516.432-1.08.672-1.655h0c.06-.156.132-.312.192-.468a1.1,1.1,0,0,0,.024-.168c.012-.4-.036-1.415-.144-2.795a7.573,7.573,0,0,0-1.3-1.919c-.12-.156-.252-.312-.372-.468a1.053,1.053,0,0,1-.1-.12c-1.547-1.9-3.562-4.15-3.562-4.162a40.439,40.439,0,0,0,8.72,2.591,26.394,26.394,0,0,0,4.078.372h.636c.372-.012.732-.024,1.08-.048,4.222-.264,6.333-1.6,7.1-1.044a11.6,11.6,0,0,1,3.6,3.551c1.391,2.795,2.747,10.435,3.9,17.129h0a96.864,96.864,0,0,0,2.207,10.975c.444,1.188,1.727,4.69,3.814,10.328C1523.86,1210.3,1535.135,1237.29,1541.793,1253.4Z",
    transform: "translate(-1483.264 -1164)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(22.462 34.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1649.76,1298.6a5.678,5.678,0,0,1-2.483-2.075c-1.152-1.607-2.327-4.726-1.463-10.424l.2.036c-.48,3.107-.612,7.413,1.427,10.28a5.275,5.275,0,0,0,2.639,2.087l-.048.2C1650.012,1298.695,1649.916,1298.659,1649.76,1298.6Z",
    transform: "translate(-1645.516 -1286.1)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(19.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1639.061,1042.778s-.084-17.717-6.021-28.944c-.816-1.535-1.056-4.462-1.224-7.665-.072-1.331-.132-2.711-.216-4.054-.012-.18-.024-.372-.036-.552-.168-2.3-7.425-.924-5.865,9.3.372,2.411,2.051,10.556-3.155,14.226C1619.209,1027.436,1633.027,1041.255,1639.061,1042.778Z",
    transform: "translate(-1622.032 -1000.604)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(0.604 22.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1463.318,1193.453l.168-1.032c.312-2.015,3.347-2.6,6.909-1.847l8.684,1.859c3.659.78,5.41,2.039,5.566,4.15a3.77,3.77,0,0,1-.18,1.26c-.7,1.955-2.519,2.891-6.166,2.123l-9.068-1.883C1465.669,1197.316,1463.006,1195.468,1463.318,1193.453Z",
    transform: "translate(-1463.293 -1190.257)",
    fill: "#f67f72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(0 30.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1458.276,1255.7l.132-1.068c.24-1.9,3.119-2.531,6.549-1.931l9.068,1.571c3.527.612,5.914,2.027,6.058,4.006a3.073,3.073,0,0,1-.168,1.175c-.66,1.847-3.275,2.471-6.789,1.871l-9.068-1.571C1460.615,1259.166,1458.024,1257.606,1458.276,1255.7Z",
    transform: "translate(-1458.259 -1252.483)",
    fill: "#f67f72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0.352 36.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1461.263,1309.087l.24-.768c.468-1.5,2.963-1.931,5.746-1.331l5.638,1.415c2.207.528,4.93,1.475,4.57,3.5-.444,2.435-4.462,2.339-5.745,1.991l-6.2-1.331C1462.714,1311.966,1460.783,1310.586,1461.263,1309.087Z",
    transform: "translate(-1461.19 -1306.727)",
    fill: "#f67f72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(15.46 26.701)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1592.706,1226.117c.324-1.583-.864-2.315-2.243-2.567l-1.739-.324a1.053,1.053,0,0,0-1.32.78l-.252,1.967a1.344,1.344,0,0,0,1.187,1.356l1.979.372A2.267,2.267,0,0,0,1592.706,1226.117Z",
    transform: "translate(-1587.146 -1223.203)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(4.226 17.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1493.513,1146.359c.024-.18.264-1.368.264-1.368.372-1.679,2.831-1.9,5.59-1.14l6.166,1.679c2.831.768,4.57,1.26,4.714,3.095a5.094,5.094,0,0,1-.42,1.9c-.948,1.991-3.095,1.547-5.925.768l-5.914-1.188C1495.228,1149.345,1493.237,1148.062,1493.513,1146.359Z",
    transform: "translate(-1493.487 -1143.436)",
    fill: "#f67f72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(15.581 33.878)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1593.128,1285.911l.036-.12a1.915,1.915,0,0,0-1.559-2.435l-1.559-.3a1.157,1.157,0,0,0-1.307.768l-.54,1.835a1.022,1.022,0,0,0,.828,1.3l1.763.336A2.07,2.07,0,0,0,1593.128,1285.911Z",
    transform: "translate(-1588.157 -1283.036)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(11.631 39.681)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1559.011,1333.406l-.012.036a1.654,1.654,0,0,1-1.823,1.392l-1.4-.276a.751.751,0,0,1-.528-.936l.312-1.452a.894.894,0,0,1,.972-.744l1.547.3A1.384,1.384,0,0,1,1559.011,1333.406Z",
    transform: "translate(-1555.224 -1331.417)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(16.351 20.634)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1598.74,1175.525l.06-.288a2.044,2.044,0,0,0-1.583-2.267l-1.212-.312a.838.838,0,0,0-1.079.624l-.336,1.787a1.089,1.089,0,0,0,.84,1.2l1.391.348A1.493,1.493,0,0,0,1598.74,1175.525Z",
    transform: "translate(-1594.574 -1172.626)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(5.271 30.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1502.236,1252.42a.073.073,0,0,1-.036-.072.066.066,0,0,1,.072-.048l13,2.447a.061.061,0,0,1-.024.12l-13.015-2.447Z",
    transform: "translate(-1502.2 -1252.3)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(6.263 22.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1510.513,1190.52a.058.058,0,0,1-.036-.072.066.066,0,0,1,.072-.048l12.5,2.747a.061.061,0,1,1-.024.12l-12.511-2.747C1510.525,1190.532,1510.513,1190.532,1510.513,1190.52Z",
    transform: "translate(-1510.473 -1190.4)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(3.1 36.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1484.136,1306.82a.073.073,0,0,1-.036-.072.066.066,0,0,1,.072-.048l10.58,2.111c.036,0,.048.036.048.072a.066.066,0,0,1-.072.048l-10.592-2.111Z",
    transform: "translate(-1484.1 -1306.7)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(27.54 1.619)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1688.218,1018.49c.612.336,1.751-.336,1.751-.336-.072-1.331-.132-2.711-.216-4.054a1.622,1.622,0,0,0-1.38.648C1687.834,1015.6,1687.606,1018.154,1688.218,1018.49Z",
    transform: "translate(-1687.852 -1014.1)",
    fill: "#ffb0a1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(7.088 44.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 18.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M419.074,706.242s-2.867.947-5.158,1.823c-.048.024-.1.036-.144.06-.192.072-.384.144-.564.216a7.856,7.856,0,0,0-2.087,1.008c-.78,1.14-1.331,1.991-1.523,2.339-.036.072-.06.132-.072.156l-.072.5h0c-.084.624-.168,1.211-.24,1.775a.091.091,0,0,1-.012.048c0,.024-.012.036-.012.06a.108.108,0,0,1-.012.06,1.052,1.052,0,0,0-.024.192c-.024.192-.06.384-.084.576-.012.048-.012.1-.024.144-.156,1.092-.288,1.955-.36,2.471,0,.036-.012.084-.012.108-.036.264-.06.408-.06.408a4.9,4.9,0,0,1,2.6.852,2.764,2.764,0,0,1,.852,1.056,2.1,2.1,0,0,1,.144.384c.036.132.132.7.252,1.463a.09.09,0,0,0,.012.048,3.06,3.06,0,0,0,.06.324c.036.168.06.312.1.444a1.256,1.256,0,0,1,.048.2c.384,1.367.792,1.559-.828,3.095-.24.228-.8.816-1.679,1.547a18.2,18.2,0,0,1-10.22,4.294c-3.73.276-7.773-.192-10.088.324-2.087.468-11.923,3.766-23.366,7.713a169.373,169.373,0,0,0,2.375-21.315c1.835-.276,3.6-.576,5.278-.9,2.279-.432,5.206-2.651,8.421-6.5h0c4.354-5.218,9.344-11.143,11.947-12.871a11.566,11.566,0,0,1,4.894-1.271c.936-.1,2.1,2.123,5.614,4.462.288.192.6.384.912.576.18.108.36.216.552.324a25.915,25.915,0,0,0,3.719,1.715A43.39,43.39,0,0,0,419.074,706.242Z",
    transform: "translate(-366.5 -697.075)",
    fill: "#ff9280"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(22.155 32.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M552.1,823.772a3.371,3.371,0,0,1-.9-.1l.06-.2a5.346,5.346,0,0,0,3.347-.492c1.763-.8,4.294-2.879,6.357-8.181l.192.072c-1.163,2.963-3.227,6.813-6.477,8.3A6.068,6.068,0,0,1,552.1,823.772Z",
    transform: "translate(-551.2 -814.8)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(16.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M500.6,577.556s8.948-15.294,19.7-22.035c1.475-.924,3.143-3.347,4.894-6.022.732-1.116,1.475-2.279,2.219-3.395.108-.156.2-.312.312-.456,1.3-1.907,6.9,2.915.42,10.987-1.523,1.907-7.065,8.109-4.39,13.89C525.454,574.209,506.586,579.259,500.6,577.556Z",
    transform: "translate(-500.6 -545.233)",
    fill: "#ff9280"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(31.541 21.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(3.293 4.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M677.472,778.251l.372-.972c.732-1.907-1.6-3.934-5.062-5.062l-8.445-2.735c-3.55-1.164-5.71-.948-6.9.8a3.418,3.418,0,0,0-.468,1.188c-.384,2.039.732,3.766,4.282,4.918l8.792,2.9C673.514,780.422,676.741,780.158,677.472,778.251Z",
    transform: "translate(-656.901 -768.758)",
    fill: "#ffa089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 11.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M650.1,831.151l.42-1c.744-1.763-1.439-3.742-4.7-4.954l-8.637-3.179c-3.359-1.235-6.13-1.211-7.245.444a2.891,2.891,0,0,0-.444,1.1c-.36,1.919,1.6,3.778,4.942,5.014l8.637,3.179C646.342,832.974,649.365,832.926,650.1,831.151Z",
    transform: "translate(-629.446 -821.153)",
    fill: "#ffa089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(1.918 18.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M660.989,892.139l.18-.792c.348-1.535-1.607-3.155-4.306-4.031l-5.59-1.6c-2.183-.648-5.014-1.187-5.71.744-.84,2.327,2.687,4.258,3.982,4.594l6.045,1.955C658.29,893.9,660.653,893.674,660.989,892.139Z",
    transform: "translate(-645.435 -885.125)",
    fill: "#ffa089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(4.561 5.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M667.532,779.571c.516-1.535,1.907-1.571,3.227-1.1l1.667.588a1.058,1.058,0,0,1,.756,1.343l-.768,1.835a1.357,1.357,0,0,1-1.7.588l-1.9-.672A2.292,2.292,0,0,1,667.532,779.571Z",
    transform: "translate(-667.468 -778.204)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(7.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M707.838,735.875c.072-.18.456-1.308.456-1.308.516-1.643-1.5-3.059-4.27-3.79l-6.189-1.631c-2.831-.744-4.594-1.2-5.638.324a4.762,4.762,0,0,0-.576,1.847c-.18,2.2,1.907,2.891,4.75,3.634l5.71,1.931C704.851,737.6,707.214,737.482,707.838,735.875Z",
    transform: "translate(-691.61 -728.457)",
    fill: "#ffa089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(1.158 12.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M639.145,831.256l.036-.12a1.921,1.921,0,0,1,2.567-1.331l1.5.528a1.167,1.167,0,0,1,.744,1.331l-.456,1.859a1.017,1.017,0,0,1-1.355.708l-1.691-.588A2.118,2.118,0,0,1,639.145,831.256Z",
    transform: "translate(-639.097 -829.683)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(3.091 19.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M655.323,892.145l-.012.024a1.667,1.667,0,0,0,.888,2.123l1.355.468a.767.767,0,0,0,.936-.54l.468-1.415a.885.885,0,0,0-.468-1.128L657,891.161A1.372,1.372,0,0,0,655.323,892.145Z",
    transform: "translate(-655.217 -891.101)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(8.028 0.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M696.446,736.534l.1-.276a2.048,2.048,0,0,1,2.507-1.176l1.2.336a.848.848,0,0,1,.624,1.08l-.6,1.727a1.089,1.089,0,0,1-1.331.624l-1.379-.4A1.519,1.519,0,0,1,696.446,736.534Z",
    transform: "translate(-696.37 -734.999)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(5.088 11.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M684.414,826.865h-.024l-12.487-4.39a.057.057,0,1,1,.036-.108l12.487,4.39a.053.053,0,0,1,.036.072C684.462,826.853,684.438,826.865,684.414,826.865Z",
    transform: "translate(-671.862 -822.363)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(8.243 4.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M710.414,772.861h-.024L698.2,768.975a.057.057,0,0,1,.036-.108l12.187,3.886a.053.053,0,0,1,.036.072C710.462,772.849,710.438,772.861,710.414,772.861Z",
    transform: "translate(-698.163 -768.863)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(5.987 18.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M689.635,889.841h-.024L679.4,886.375a.057.057,0,0,1,.036-.108l10.208,3.467a.055.055,0,0,1-.012.108Z",
    transform: "translate(-679.362 -886.262)",
    fill: "#e87765"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(40.675 0.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M706.943,557.058c-.7-.012-1.343-1.164-1.343-1.164.732-1.116,1.475-2.279,2.219-3.395a1.658,1.658,0,0,1,.876,1.26C708.719,554.743,707.639,557.07,706.943,557.058Z",
    transform: "translate(-705.6 -552.5)",
    fill: "#ffb0a1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1147.436,447.835l-1.883-.984c1.463-2.831,1.211-3.706,1.091-3.91-.264-.468-1.523-.552-2.543-.612-1.4-.1-2.867-.192-3.8-1.116a2.84,2.84,0,0,1-.876-2.3c.18-2.147,2.723-4.006,3.011-4.21l1.224,1.739-.612-.864.612.864c-.66.468-2.051,1.739-2.123,2.651a.739.739,0,0,0,.264.624,4.919,4.919,0,0,0,2.435.5c1.607.108,3.431.228,4.258,1.691.732,1.271.4,3.107-1.055,5.926Z",
    transform: "translate(-1039.613 -403.003)",
    fill: "#1c45ad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M2332,406.291l-.4-2.087c3.131-.6,3.658-1.355,3.754-1.559.2-.492-.516-1.535-1.092-2.375-.8-1.164-1.631-2.363-1.475-3.671a2.793,2.793,0,0,1,1.272-2.111c1.8-1.187,4.822-.348,5.169-.24l-.6,2.039.3-1.02-.3,1.02c-.78-.228-2.627-.528-3.395-.024a.724.724,0,0,0-.324.588c-.06.516.588,1.463,1.116,2.219.911,1.319,1.943,2.831,1.307,4.39-.588,1.355-2.219,2.231-5.338,2.831Z",
    transform: "translate(-2088.796 -367.062)",
    fill: "#7798f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1178.558,703.4l-1.919-1c1.5-2.891,1.235-3.79,1.116-3.994-.264-.48-1.559-.564-2.591-.624-1.439-.1-2.927-.192-3.874-1.14a2.87,2.87,0,0,1-.888-2.351c.192-2.2,2.783-4.078,3.071-4.294l1.247,1.775-.624-.888.624.888c-.672.48-2.087,1.775-2.171,2.711a.773.773,0,0,0,.264.636,5.079,5.079,0,0,0,2.483.516c1.643.108,3.491.228,4.342,1.727.744,1.283.42,3.155-1.079,6.034Z",
    transform: "translate(-1066.873 -627.68)",
    fill: "#7798f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1438.7,392.1l1.175-2.135c3.215,1.763,4.234,1.487,4.462,1.367.54-.288.672-1.739.78-2.9.144-1.619.288-3.287,1.391-4.33a3.282,3.282,0,0,1,2.675-.948c2.459.264,4.522,3.239,4.75,3.575l-2.027,1.367,1.007-.684-1.007.684c-.516-.768-1.931-2.4-2.987-2.507a.818.818,0,0,0-.72.288c-.432.408-.552,1.727-.648,2.783-.168,1.835-.348,3.922-2.063,4.834-1.5.792-3.6.36-6.789-1.391Z",
    transform: "translate(-1303.001 -357.624)",
    fill: "#7798f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1985.7,552.606l1.247-2.267c3.395,1.871,4.474,1.583,4.726,1.439.576-.312.708-1.835.816-3.071.156-1.715.312-3.479,1.475-4.582a3.445,3.445,0,0,1,2.831-1c2.6.288,4.786,3.419,5.026,3.779l-2.147,1.439,1.068-.72-1.068.72c-.552-.816-2.051-2.531-3.167-2.651a.862.862,0,0,0-.756.3c-.456.432-.576,1.823-.684,2.939-.168,1.943-.372,4.162-2.183,5.122-1.583.852-3.8.408-7.185-1.451Z",
    transform: "translate(-1784.388 -498.407)",
    fill: "#1c45ad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M844,408.668l.168-2.207c3.323.264,4.066-.348,4.21-.54.336-.444-.1-1.691-.444-2.687-.492-1.392-1-2.819-.48-4.09a2.964,2.964,0,0,1,1.859-1.775c2.147-.7,4.966.984,5.278,1.188l-1.164,1.883.588-.936-.588.936c-.72-.444-2.507-1.26-3.419-.96a.743.743,0,0,0-.492.5,5.12,5.12,0,0,0,.516,2.543c.552,1.583,1.188,3.371.108,4.762-.936,1.212-2.831,1.643-6.141,1.379Z",
    transform: "translate(-779.635 -370.003)",
    fill: "#ff6760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1557.9,672.233l-1.547-1.883c2.831-2.327,2.963-3.371,2.927-3.634-.072-.612-1.367-1.271-2.4-1.8-1.452-.732-2.939-1.5-3.5-2.9a3.29,3.29,0,0,1,.12-2.831c1.163-2.183,4.69-3,5.086-3.083l.5,2.387-.252-1.2.252,1.188c-.912.192-2.951.912-3.443,1.847a.833.833,0,0,0,0,.768c.216.552,1.4,1.151,2.339,1.631,1.643.84,3.515,1.787,3.73,3.706.18,1.7-1,3.491-3.814,5.806Z",
    transform: "translate(-1403.692 -597.846)",
    fill: "#ff6760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1884.568,336.028l-.768-2.315c3.479-1.14,3.97-2.075,4.042-2.327.156-.6-.816-1.679-1.6-2.543-1.079-1.211-2.207-2.459-2.219-3.97a3.242,3.242,0,0,1,1.14-2.591c1.883-1.619,5.446-1.092,5.854-1.032l-.384,2.411.192-1.2-.192,1.2c-.924-.144-3.071-.216-3.875.468a.829.829,0,0,0-.288.72c.012.6.888,1.583,1.6,2.363,1.235,1.379,2.627,2.939,2.135,4.81-.444,1.619-2.183,2.867-5.638,4.006Z",
    transform: "translate(-1694.711 -303.048)",
    fill: "#ff6760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(183.906 68.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(8.85 11.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1932.626,842.372s9.308,12.1,10.951,19.468c.144.672.348,3.443.528,4.054,1.463,4.87,8.444,9.7,11.359,11.371,2.867,1.643,6.406,3.706,10.076,6,.7.444,1.416.888,2.159,1.344-1.2,9.44-2.591,18.017-4.162,25.381-3.562-2.975-7.017-5.854-10.2-8.5q-5.254-4.372-8.936-7.425c-4.162-3.443-6.765-5.578-7.641-6.3a89.667,89.667,0,0,0-8.66-5.134c-5.338-2.975-11.419-6.381-13.386-8.4-.792-.816-.24-12.547,1.571-12.211,5.914,1.079,4.474-6.214,4.354-6.549C1917.656,846.486,1932.338,841.916,1932.626,842.372Z",
    transform: "translate(-1914.365 -842.341)",
    fill: "#fc8c7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(18.666 36.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M2006.432,1054.113l-.192-.012a4.989,4.989,0,0,0-1.14-2.951c-1.115-1.475-3.563-3.455-8.9-4.558l.036-.192c2.987.612,6.981,1.919,9.032,4.642A5.169,5.169,0,0,1,2006.432,1054.113Z",
    transform: "translate(-1996.2 -1046.4)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(36.502 45.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M2164.318,1121.027a4.118,4.118,0,0,0-5.974.624h0a3.055,3.055,0,0,0-.263.288,14.53,14.53,0,0,0-2.663,6.441c-1.1,5.782-5,6.8-8.145,10.064a13.538,13.538,0,0,0-1.391,1.715,13.812,13.812,0,0,0-.792,1.32c-2.567,5,21.375,23.486,24.458,26.2,1.9,1.667,28.968,20.391,31.5,20.391,4.2.012,10.627-8,13.494-10.616a80.055,80.055,0,0,0,11.779-12.823c4.138-5.89-20.4-19.828-25.753-22.886q-5.435-3.095-10.868-6.2C2181.471,1130.851,2171.887,1126.773,2164.318,1121.027Z",
    transform: "translate(-2144.898 -1120.022)",
    fill: "#ff6760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(0 17.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1863.174,924.313c.492-5.578-6.753-17.849-10.112-19.276-2.267-.96-4.762-5.782-5.59-7.821-1.763-4.39-2.4-6.6-4.726-7.4a1.528,1.528,0,0,0-2.135,1.307,8.449,8.449,0,0,0,.684,3.371c.1.3.828,6.153.948,6.489,1.3,3.73,5.254,13.015,5.254,13.015C1849.644,917.668,1863.174,924.313,1863.174,924.313Z",
    transform: "translate(-1840.586 -889.694)",
    fill: "#fc8c7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(0.016 18.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1841.422,902.864a1.854,1.854,0,0,0,.972-.336c.875-.612-.2-2.939-.4-3.239-.132-.216-.84.036-1.259.216A8.656,8.656,0,0,0,1841.422,902.864Z",
    transform: "translate(-1840.717 -899.206)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(1.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1868.156,778.105c-.564-1.379-1.871-4.534-3.682-8.493-.288-.624-.588-1.271-.9-1.931-.132-.288-.276-.576-.408-.864-.24-.516-.5-1.044-.768-1.571-.516-1.02-1.068-2.063-1.62-3.095-2.147-4.018-3.718-8-3.862-10.112-.048-.708-.228-2.663,1.907-2.039,2.783.816,4.87,4.834,5.614,5.638,0,0-6.285-8.912-4.27-10.652,2.939-2.531,9.32,8.517,9.32,8.517s-4.8-7.473-3.742-8.948c2.855-3.946,13.95,15.69,13.95,15.69s-6.789-9.536-5.278-10.556c2.567-1.739,11.551,12.355,12.067,13.027h0c2.039,2.675,3.3,7.173,4.678,10.736C1892.362,776.558,1868.264,778.369,1868.156,778.105Z",
    transform: "translate(-1856.891 -744.031)",
    fill: "#fc8c7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(7.082 10.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1923.273,846.387l-.012.012a.14.14,0,0,1-.192-.06c-1.979-3.922-7.053-12.007-7.113-12.091a.14.14,0,0,1,.24-.144c.048.084,5.134,8.181,7.125,12.1A.144.144,0,0,1,1923.273,846.387Z",
    transform: "translate(-1915.936 -834.036)",
    fill: "#e87b69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(11.371 7.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1961.225,821.195c0,.012-.012.012,0,0a.138.138,0,0,1-.2-.048c-2.255-3.994-9.236-14.034-9.308-14.142a.136.136,0,0,1,.036-.192h0a.136.136,0,0,1,.192.036c.072.1,7.053,10.16,9.32,14.166A.132.132,0,0,1,1961.225,821.195Z",
    transform: "translate(-1951.687 -806.787)",
    fill: "#e87b69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(17.836 8.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M2014.237,825.923a.043.043,0,0,1-.024.012.14.14,0,0,1-.192-.06c-1.164-2.339-8.337-13.063-8.409-13.171a.136.136,0,0,1,.036-.192h0a.135.135,0,0,1,.192.036c.072.108,7.257,10.856,8.421,13.207A.1.1,0,0,1,2014.237,825.923Z",
    transform: "translate(-2005.587 -812.487)",
    fill: "#e87b69"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(192.474 76.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(0.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M2011.865,848.578c-11.983-4.57-29.292-13.182-38.612-14.454a9.078,9.078,0,0,0-4.1.648c-2.639.924-5.71,2.519-9.488,3.371-2.663.6-5.542,1.464-7.929,2.255h0c-2.219.744-4.018,1.427-4.81,1.775-.612.276-2.567.936-3.73,1.523-.036.012-.06.036-.1.048-2.063,1.032-4.5,1.823-5.146.768a.976.976,0,0,1-.12-.3,1.388,1.388,0,0,1-.048-.216h0c-.36-1.907.852-4.546,8.516-9.26h0c1.176-.72,2.5-1.487,3.983-2.315.7-.384.048-1.176-.252-1.26-1.008-.276-2.831-.78-5.218-1.391-1.4-.36-3-.756-4.726-1.164-.168-.036-.324-.072-.492-.12-.588-.144-1.187-.276-1.811-.42-.348-.072-.684-.156-1.031-.228-.624-.132-1.248-.264-1.9-.4-1.247-.24-2.531-.468-3.814-.684a50.438,50.438,0,0,1-9.116-2.339,12.175,12.175,0,0,1-2.375-1.164,5.521,5.521,0,0,1-.852-.66c-.6-.588-.984-1.439.36-2.411l.108-.072a6.187,6.187,0,0,1,2.123-.864,10.7,10.7,0,0,1,1.079-.18,44.213,44.213,0,0,1,5.434.036c-.168-.012-2.9-.144-5.745-.6-.228-.036-.456-.072-.684-.12-2.351-.42-4.642-1.068-5.47-2.039a1.257,1.257,0,0,1-.324-.756,1.781,1.781,0,0,1,.9-1.631h0a6.492,6.492,0,0,1,2.447-.864,28.3,28.3,0,0,1,6.081-.252h0l.612.036c.732.048,1.391.1,1.955.144-.156-.024-.324-.036-.492-.06h-.024c-.48-.06-1-.144-1.547-.228-.108-.012-.216-.036-.324-.048-2.747-.456-5.89-1.2-6.189-2.267a1.454,1.454,0,0,1-.012-.816v-.012a1.491,1.491,0,0,1,.612-.768h0a6.449,6.449,0,0,1,2.675-.888,32.539,32.539,0,0,1,5.446-.3h.312c1.463.024,2.987.1,4.462.2-.156-.036-.312-.072-.456-.1h0a8.027,8.027,0,0,1-2.039-.684h0c-.408-.228-.636-.468-.612-.744.036-.444.372-.8.936-1.092h.012c3.8-1.919,17.861-.612,18.664-.6a23.2,23.2,0,0,1,6.166,1.164c2.171.648,4.39,1.439,6.417,2.051,3.538,1.068,7.833,3.754,10.1,4.99a11.966,11.966,0,0,0,1.307.588c4.7,1.847,16.637,4.594,28.176,7.029h0C2008.062,828.822,2012.177,838.322,2011.865,848.578Z",
    transform: "translate(-1915.578 -804.182)",
    fill: "#ffa089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(2.651 15.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1938.3,937.774l-.24,1.763a.383.383,0,0,1-.456.312l-2.4-.336a1.206,1.206,0,0,1-1.08-1.307l.024-.168a1.279,1.279,0,0,1,1.475-1.032l2.327.324A.415.415,0,0,1,1938.3,937.774Z",
    transform: "translate(-1934.12 -936.994)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(0 9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1916.2,886.56l-.24,1.727a.391.391,0,0,1-.456.312l-2.4-.336a1.191,1.191,0,0,1-1.079-1.284l.024-.168a1.272,1.272,0,0,1,1.476-1.008l2.327.324A.387.387,0,0,1,1916.2,886.56Z",
    transform: "translate(-1912.021 -885.792)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(3.839 4.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1947.309,842.965l-.216,1.571a.331.331,0,0,1-.36.288l-1.871-.252a1.011,1.011,0,0,1-.828-1.151l.024-.144a1.075,1.075,0,0,1,1.175-.936l1.811.252A.327.327,0,0,1,1947.309,842.965Z",
    transform: "translate(-1944.026 -842.333)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(14.271 1.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2033.625,813.188l-.012,1.307a.269.269,0,0,1-.264.276l-1.559-.012a.813.813,0,0,1-.792-.852v-.12a.873.873,0,0,1,.864-.888l1.511.012A.267.267,0,0,1,2033.625,813.188Z",
    transform: "translate(-2030.997 -812.9)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(22.116 37.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M2102.266,1121.636l-.564-1.355a.639.639,0,0,0-.84-.36l-3.346,1.487a2.1,2.1,0,0,0-1.115,1.235C2097.132,1123.843,2099.939,1122.871,2102.266,1121.636Z",
    transform: "translate(-2096.4 -1119.869)",
    fill: "#ffb0a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(11.729 14.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M2025.49,928.291a.14.14,0,0,1-.12.024c-4.774-.936-15.318-1.991-15.425-2a.156.156,0,0,1,.024-.312c.108.012,10.663,1.068,15.45,2a.144.144,0,0,1,.12.18A.152.152,0,0,1,2025.49,928.291Z",
    transform: "translate(-2009.8 -926)",
    fill: "#e87b69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(11.787 8.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M2029.266,877.854a.122.122,0,0,1-.108.024c-5.038-.744-18.58-1.463-18.724-1.475a.156.156,0,0,1,.024-.312c.132.012,13.7.732,18.748,1.475a.161.161,0,0,1,.132.18A.175.175,0,0,1,2029.266,877.854Z",
    transform: "translate(-2010.289 -876.089)",
    fill: "#e87b69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(16.789 3.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M2069.515,834.486a.14.14,0,0,1-.12.024c-2.843-.576-17.117-1.6-17.261-1.607a.156.156,0,0,1,.024-.312c.144.012,14.442,1.031,17.3,1.607a.145.145,0,0,1,.12.18A.182.182,0,0,1,2069.515,834.486Z",
    transform: "translate(-2051.989 -832.589)",
    fill: "#e87b69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(246.244 81.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M2392.592,857.536l7.557,1.811c-2.531-3.095-4.714-9.968-7.892-12.739-8.145-.888-22.143.588-22.467.516a4.125,4.125,0,0,0-5.242,2.951,3.385,3.385,0,0,0-.12.372c-.012.024-.012.048-.024.06a14.419,14.419,0,0,0,.144,6.909c1.284,5.758-1.9,8.229-3.466,12.463a12.6,12.6,0,0,0-.564,1.979.6.6,0,0,0-.024.144,14.575,14.575,0,0,0-.2,1.523c-.216,3.263,23.882,11.7,42.415,17.321a35.1,35.1,0,0,0,.528-5.182C2403.544,875.409,2399.43,865.909,2392.592,857.536Z",
    transform: "translate(-2360.289 -846.323)",
    fill: "#ff6760"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(307.407 170.454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(18.843 87.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(42.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M823.831,908.577a12.886,12.886,0,0,0,.408,2.711c.516,1.631-1.547,15.558-2.063,17.9s-1.775,10.052-1.775,10.052l14.526,9.536s2.219-3.79,3.586-5.542,10.568-8.037,12.931-10.172,15.354-9.38,13.962-11.779-14.022,6.9-14.6,5.326,16.073-15.486,13.926-18.328c-2.4-3.179-14.838,12.631-15.846,11.383s14.766-17.669,11.131-20.392c-2.771-2.075-14.79,16.973-16.313,15.773s8.672-16.613,5.554-18.688c-2.207-1.463-6.489,6.849-10.688,12.607-3.263,4.474-6.093,8-7.2,9.356a.291.291,0,0,1-.516-.18c-.468-10.544-3.647-13.662-5.59-13.974a1.064,1.064,0,0,0-.276,0C823.915,904.306,823.711,906.561,823.831,908.577Z",
    transform: "translate(-820.4 -896.184)",
    fill: "#d96559"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(0 42.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M485.971,1285.418,464.5,1320.263q7.287.558,14.526.672c5.374.108,10.736.06,16.073-.084l7.545-17.525,1.751-3.91,1.188-2.675,1.811-4.054,14.97-33.466h0l.108-.24-15.186-8.781h0L489.8,1279.084l-1.487,2.447Z",
    transform: "translate(-464.5 -1250.2)",
    fill: "#d96559"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(54.074 3.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M978.764,940.752a7.993,7.993,0,0,0,.6,3.179c.048.144.108.3.156.444a13.417,13.417,0,0,0,1.2,2.459c.984,1.4,3.215,15.306,3.431,17.693.18,1.991.984,7.7,1.247,9.536.048.372.084.576.084.576l16.721,4.714s.108-.492.288-1.236c.348-1.427.948-3.754,1.463-5.134.78-2.087,7.665-10.844,9.272-13.59s11.815-13.578,9.764-15.438-11.3,10.8-12.319,9.476,10.664-19.612,7.749-21.675c-3.251-2.3-10.34,16.517-11.683,15.618s8.756-21.291,4.474-22.791c-3.263-1.139-8.984,20.643-10.8,19.948s3.275-18.448-.336-19.492c-2.543-.732-4.114,8.481-6.393,15.246-1.763,5.242-3.407,9.464-4.054,11.083a.3.3,0,0,1-.552-.012c-3.622-9.908-7.593-11.923-9.548-11.647a.953.953,0,0,0-.264.072A1.21,1.21,0,0,0,978.764,940.752Z",
    transform: "translate(-978.745 -924.54)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(0 49.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M915.3,1396.312c1.859-.108,3.707-.228,5.554-.348,3.766-.24,7.521-.48,11.251-.7h0c2.879-.168,5.734-.336,8.589-.48l.456-5.53.492-4.246.336-2.9h0l.5-4.414h0l4.186-36.417h0v-.012l.036-.264-17.129-3.8h0l-7.977,32.819-.672,2.783-1.068,4.4h0Z",
    transform: "translate(-915.3 -1337.2)",
    fill: "#e87765"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(2.849 86.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M964.957,1661.1c.96.036,1.547-.2,1.823-.7.48-.888-.468-2-.78-2.375a21.352,21.352,0,0,0-3.107-2.783.557.557,0,1,0-.672.888c3.083,2.339,3.634,3.49,3.586,3.73-.156.144-1.26.324-4.378-.72a70.676,70.676,0,0,1-18.244-9.86c-2.579-2.039-3.035-3.059-3-3.275.036-.024.264-.18,1.128-.084a.56.56,0,1,0,.108-1.115c-.444-.048-1.775-.192-2.231.66-.528.971.456,2.411,3.107,4.534a62.705,62.705,0,0,0,9.1,5.854,63.925,63.925,0,0,0,9.884,4.414A13.843,13.843,0,0,0,964.957,1661.1Z",
    transform: "translate(-939.054 -1644.768)",
    fill: "#180c7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(3.406 81.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M970.321,1619.818c1.391.048,2.2-.24,2.459-.888.72-1.74-3.61-4.27-5.038-5.1a.562.562,0,0,0-.564.972c3.815,2.219,4.582,3.431,4.558,3.694-.132.168-1.211.456-4.426-.252a62.193,62.193,0,0,1-9.872-3.251,62.965,62.965,0,0,1-9.3-4.666c-2.771-1.763-3.335-2.723-3.323-2.939.036-.036.348-.276,1.7-.18a.559.559,0,0,0,.084-1.116c-1.032-.072-2.447-.072-2.831.864-.42,1.019.708,2.351,3.563,4.186a63.56,63.56,0,0,0,9.656,4.882,62.189,62.189,0,0,0,10.292,3.359A20.268,20.268,0,0,0,970.321,1619.818Z",
    transform: "translate(-943.691 -1606.068)",
    fill: "#180c7a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(118.027 98.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M1291.615,990.3l.78.36a.455.455,0,0,0,.612-.228l.5-1.08a.868.868,0,0,0-.42-1.151h0a.868.868,0,0,0-1.152.42l-.528,1.127A.411.411,0,0,0,1291.615,990.3Z",
    transform: "translate(-1291.372 -988.119)",
    fill: "#ff8a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(111.301 91.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1235.636,933.133l.96.288a.536.536,0,0,0,.672-.36l.288-.936a1.009,1.009,0,0,0-.672-1.26h0a1.009,1.009,0,0,0-1.26.672l-.3.984A.479.479,0,0,0,1235.636,933.133Z",
    transform: "translate(-1235.3 -930.82)",
    fill: "#ff8a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(100.312 91.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1144.1,938.259l1,.132a.538.538,0,0,0,.6-.456l.132-.96a1.013,1.013,0,0,0-.864-1.14h0a1.014,1.014,0,0,0-1.14.864l-.144,1.02A.493.493,0,0,0,1144.1,938.259Z",
    transform: "translate(-1143.682 -935.828)",
    fill: "#ff8a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(80.527 106.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M978.764,1059.5a7.993,7.993,0,0,0,.6,3.179l.732-.2a.608.608,0,0,0,.42-.744l-.408-1.427A1.137,1.137,0,0,0,978.764,1059.5Z",
    transform: "translate(-978.745 -1059.468)",
    fill: "#ff8a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(122.52 110.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1328.966,1090.543l.612.48a.4.4,0,0,0,.576-.072l.588-.768a.78.78,0,0,0-.132-1.091h0a.781.781,0,0,0-1.092.132l-.612.792A.379.379,0,0,0,1328.966,1090.543Z",
    transform: "translate(-1328.825 -1088.927)",
    fill: "#ff8a7f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsClapping);
export default __webpack_public_path__ + "static/media/hands-clapping.35679116f5e47b821ebfffd7aa976ed3.svg";
export { ForwardRef as ReactComponent };